import { lazyNamed, lazyWithRetry } from "src/utils/lazy-named";
import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

const connectionsImport = () => import(".");
const ConnectionsLoader = lazyWithRetry(connectionsImport);

export const preloads: RoutePreload[] = [["/connections", connectionsImport]];
const Connection = lazyNamed(() => import("./connection"), "Connection");
const CreateConnection = lazyNamed(
  () => import("./connection"),
  "CreateConnection",
);
const Overview = lazyNamed(() => import("./connection/overview"), "Overview");
const Configuration = lazyNamed(
  () => import("./connection/configuration"),
  "Configuration",
);
const Schema = lazyNamed(() => import("./connection/schema"), "Schema");
const Schedule = lazyNamed(() => import("./connection/schedule"), "Schedule");
const Runs = lazyNamed(() => import("./connection/runs"), "Runs");

export const routes: RouteObject[] = [
  {
    path: "connections",
    spacesAccess: "hidden-from-limited-view",
    element: <ConnectionsLoader />,
    children: [],
  },
  {
    path: "connections/new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateConnection />,
  },
  {
    path: "connections/:connection_id/*",
    spacesAccess: "hidden-from-limited-view",
    element: <Connection />,
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <Navigate to="overview" replace />,
      },
      {
        path: "overview",
        spacesAccess: "hidden-from-limited-view",
        element: <Overview />,
      },
      {
        path: "configuration",
        spacesAccess: "hidden-from-limited-view",
        element: <Configuration />,
      },
      {
        path: "schema",
        spacesAccess: "hidden-from-limited-view",
        element: <Schema />,
      },
      {
        path: "schedule",
        spacesAccess: "hidden-from-limited-view",
        element: <Schedule />,
      },
      {
        path: "runs",
        spacesAccess: "hidden-from-limited-view",
        element: <Runs />,
      },
    ],
  },
];
